module.exports = __webpack_public_path__ + "static/img/Facebook.30a26e70.png";